export default function FamilyAndVersion(props) {
  const { family, version } = props || {}
  if (!family && !version) return null
  return `${family || ''}${version && family ? ' ' : ''}${version || ''}`
}
